import { defineStore } from 'pinia'
import { ref } from 'vue'
import Cache from '@/utils/cache'

export const useOrderStore = defineStore('order', () => {
    const orderList = ref(Cache.get('ORDER_LIST'))

    const setOrderList = (e) => {
        orderList.value = e
        Cache.add('ORDER_LIST', e, 7200)
    }
    return {
        orderList,

        setOrderList
    }
})
